import { Endpoints } from "~constants/endpoints"
import {
  Holdings,
  PortfolioPayload,
  PortfolioResponse,
  Security,
} from "~shapes/portfolio"
import { Api } from "~utils/api"

const PortfolioService = {
  getSecurities: async (): Promise<Security[]> => {
    const url = `${Endpoints.SECURITIES.URL}`
    const response = await Api.get(url)
    return response.data.data
  },
  getUserAggregatedPortfolios: async (userId: string): Promise<Holdings[]> => {
    const url = Endpoints.AGGREGATED_PORTFOLIOS.URL.replace(":userId", userId)
    const response = await Api.get(url, {
      headers: {
        "Cache-Control": "no-cache",
      },
    })
    return response.data
  },
  getUserPortfolio: async (userId: string): Promise<PortfolioResponse[]> => {
    const url = `${Endpoints.PORTFOLIOS.URL}?userId=${userId}`
    const response = await Api.get(url, {
      headers: {
        "Cache-Control": "no-cache",
      },
    })
    return response.data
  },
  postUserPortfolio: async (payload: PortfolioPayload) => {
    try {
      const response = await Api.post(
        `${Endpoints.PORTFOLIOS.URL}?userId=${payload.userId}`,
        payload
      )
      return response.data
    } catch (error) {
      return Promise.reject(error)
    }
  },
  invalidatePortfolio: async (payload: any) => {
    try {
      const response = await Api.put(`${Endpoints.PORTFOLIOS.URL}`, payload)
      return response
    } catch (error) {
      return Promise.reject(error)
    }
  },
}

export default PortfolioService
